export interface BackButtonProps {
  wasShown: boolean;
  isShown: boolean;
}

export enum BackButtonSearchParams {
  TITLE = 'backButtonTitle',
  TO = 'backButtonTo',
}
